import { Component } from 'react';
import { FaShareAlt } from 'react-icons/fa';
import { Navbar, Container, Nav } from 'react-bootstrap';

class NavbarComponent extends Component {
    render() {
        return (
            <div id='navbar'>
                <Navbar collapseOnSelect expand="lg" fixed="top">
                    <Container>
                        <Navbar.Brand id="navbar-link" href="#" aria-label="Subir al tope de la página">
                            <img
                                src="/images/MUSASHI.png"
                                alt="MUSASHI"
                                height="50"
                                width="52"
                                className="d-inline-block align-top"
                                loading="lazy"
                                decoding="async"
                            />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="me-auto">
                                <Nav.Link className="navbar-link" href="#planes">PLANES</Nav.Link>
                                <Nav.Link className="navbar-link" href="#nosotros">NOSOTROS</Nav.Link>
                                <Nav.Link className="navbar-link" href="#contacto">CONTACTO</Nav.Link>
                                <Nav.Link className="navbar-link" href="#social" aria-label="Ir a las redes sociales"><FaShareAlt /></Nav.Link>
                            </Nav>
                            <Nav>
                                <Nav.Link className="navbar-link" href="https://musashijj.cl/login">INICIAR SESIÓN</Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
        );
    }
}

export default NavbarComponent;
